import EmpresasAdminTemplate from "../components/templates/EmpresasAdminTemplate"

const EmpresasAdmin = () => {
    return <EmpresasAdminTemplate/>;
};

export default EmpresasAdmin;